import { Component, Vue } from 'vue-property-decorator'
import DefaultLayout from '@/components/Layouts/Default'
import GameFooter from '@/components/Game/Footer';
import Draft from '@/components/Draft/Draft';

@Component
export default class DraftHistory extends Vue {
  private render(h: any) {
    return (
        <DefaultLayout>
            <div slot='navigation'>
              <h1 class='navigation-title'>{this.$route.meta.title}</h1>
              <router-link class='navigation-link home' to='/account'>Account</router-link>
            </div>
            
            <Draft></Draft>
            <GameFooter></GameFooter>
        </DefaultLayout>
    );
  }
}
